export class InvoiceDelegationDetail {
  public AmountPackageTaxIncluded: number | null;
  public AmountRemainsTaxIncluded: number | null;
  public CreatedAt: number;
  public CreditorId: number | null;
  public CreditorName: string;
  public DelegateId: number | null;
  public DelegateName: string | null;
  public Id: string | null;
  public InvoiceId: string | null;
  }
